module.exports = __webpack_public_path__ + "static/media/esquina.d088fac1.png";